import { render } from "./UserPermission.vue?vue&type=template&id=48ae835e&scoped=true"
import script from "./UserPermission.vue?vue&type=script&lang=js"
export * from "./UserPermission.vue?vue&type=script&lang=js"

import "./UserPermission.vue?vue&type=style&index=0&id=48ae835e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ae835e"]])

export default __exports__